import React, { FC } from 'react'
import styled from 'styled-components'
import { Button, contentColorStyle } from './button'
import RedirectIconSvg from '@tuhi/components/assets/images/redirectIcon.svg'

const Container = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;

    border: 1px solid ${(p) => p.theme.colors.blue.blue200};

    background-color: ${(p) => p.theme.colors.white};

    ${(p) => contentColorStyle(p.theme.colors.blue.blue200)}

    &:hover {
        border: 1px solid ${(p) => p.theme.colors.blue.blue200};
        background-color: ${(p) => p.theme.colors.blue.blue100};
    }

    &:active {
        border: 2px solid ${(p) => p.theme.colors.blue.blue200};
    }
`

const ChildrenContainer = styled.div`
    display: flex;
`

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode
}

export const RedirectButton: FC<Props> = ({ children, ...rest }) => {
    return (
        <Container height="large" width="large" {...rest}>
            <ChildrenContainer>{children}</ChildrenContainer>
            <RedirectIconSvg />
        </Container>
    )
}
